<template>
  <g>
    <path
      d="M12 16.0002C13.01 16.0002 13.91 15.6102 14.62 15.0002H9.38C10.09 15.6102 10.99 16.0002 12 16.0002Z"
    />
    <path
      d="M8.56006 14.0002H15.4501C15.7101 13.5502 15.8901 13.0402 15.9601 12.5002H8.06006C8.12006 13.0402 8.29006 13.5502 8.56006 14.0002Z"
    />
    <path
      d="M12 8.00018C10.99 8.00018 10.09 8.39018 9.38 9.00018H14.62C13.91 8.39018 13.01 8.00018 12 8.00018Z"
    />
    <path
      d="M8.56005 10.0002C8.30005 10.4502 8.12005 10.9602 8.05005 11.5002H15.95C15.88 10.9602 15.71 10.4502 15.44 10.0002H8.56005Z"
    />
    <path
      d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM12 18.0002C8.69 18.0002 6 15.3102 6 12.0002C6 8.69018 8.69 6.00018 12 6.00018C15.31 6.00018 18 8.69018 18 12.0002C18 15.3102 15.31 18.0002 12 18.0002Z"
    />
  </g>
</template>
